import React from "react";
import BaseTable, { Column } from "react-base-table"
import 'react-base-table/styles.css'

class ConvGO extends React.Component{
    constructor(props){
        super(props)
        this.state={
            iterator:0
        }
    }
    render(){ 
        const columnEch = [
            {
                key: 'box1',
                dataKey: 'box1',
                width: 300,
                flexGrow:1,
                flexShrink:0,
                cellRenderer: ({cellData,rowIndex}) => (<div>
                    <input type="checkbox"  name="conv" 
                    onChange={(event) => this.props.handleChange(event,rowIndex)} 
                    checked={this.props.valueArray[rowIndex]}/>
                    {cellData}
                </div>)
              },
        ]
        const dataEch =[
            {
                box1: "Echafaudage(s) tubulaires(s)",
            },
            {
                box1: "Echafaudage(s) roulant(s)",
            },
            {
                box1: "Plate(s)-formes suspendue(s) motorisée(s)",
            },
            {
                box1: "Plate(s)-forme(s) suspendue(s) mue(s) à bras",
            },
            {
                box1: "Plate(s)-forme(s) sur mât(s)",
            },
            {
                box1: "Plate(s)-forme(s) suspendue(s) mue(s) à bras",
            },
        ]
        const columnGrue = [
            {
                key: 'box1',
                dataKey: 'box1',
                width: 300,
                flexGrow:1,
                flexShrink:0,
                cellRenderer: ({cellData,rowIndex}) => (<div>
                    <input type="checkbox"  name="conv" 
                    onChange={(event) => this.props.handleChange(event,rowIndex+6)} 
                    checked={this.props.valueArray[rowIndex+6]}/>
                    {cellData}
                </div>)
              },
        ]
        const dataGrue =[
            {
                box1: "Grue à Tour",
            },
            {
                box1: "Monte-Charge",
            },
            {
                box1: "Treuil ",
            },
            {
                box1: "Ascenseur",
            },
            {
                box1: "Grue Mobile",
            },
        ]
        return(
            <div className="testTable">
                <BaseTable  columns={columnEch} width={400} height={300} data={dataEch} headerHeight={0}>
                </BaseTable>
                <BaseTable  columns={columnGrue} width={400} height={250} data={dataGrue} headerHeight={0}>
                </BaseTable>
            </div>
        )
    }
}
export default ConvGO